export default __webpack_public_path__ + "static/media/Commander's Vambraces of the Watchtowers.f3f2f7b4.jpg";